<template>
  <div
    class="PropertyProjectInformationInquiryList vheight container-boot PublicInformationView"
  >
    <div
      class="container-boot"
      :style="{ height: 'calc(100% - 45px - ' + headerHeight + 'px )' }"
    >
      <div class="row">
        <div class="col-md-2 col-xs-12 default-col">
          <div class="search">
            <div class="search-panel">
              <div class="search-tips">人员姓名</div>
              <el-input
                placeholder="人员姓名"
                v-model="name"
                clearable
              ></el-input>
            </div>
            <div class="search-panel">
              <div class="search-tips">企业名称</div>
              <el-input
                placeholder="企业名称"
                v-model="orgNme"
                clearable
              ></el-input>
            </div>
            <div class="search-button">
              <el-button type icon="el-icon-search" @click="getData('clear')"
                >搜索</el-button
              >
            </div>
          </div>
        </div>
        <!-- 表格内容 -->
        <div class="col-md-10 col-xs-12 default-col table-grid">
          <div class="container-header">
            <!-- <span>数据下载：</span>
            <ps-export @click="epoxrtExcel">导出EXCEL</ps-export>-->
          </div>
          <div class="grid">
            <el-table
              ref="multipleTable"
              :data="dataFeed"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              stripe
              border
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
            >
              <!-- 加载的时候不要显示暂无数据 -->
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                type="index"
                label="序号"
                width="50"
              ></el-table-column>
              <el-table-column
                label="人员姓名"
                max-width="220"
                prop="FullName"
                show-overflow-tooltip
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    class="row-name"
                    @click="
                      handleDetail(
                        scope.row.OrgCode,
                        scope.row.EmployeeNumber,
                        scope.row.Job
                      )
                    "
                    style="color: #2a7bbe"
                    >{{ scope.row.FullName || '--' }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                :formatter="formatter"
                label="性别"
                max-width="200"
                prop="Gender"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.Gender || '--' }}
                </template>
              </el-table-column>
              <el-table-column
                :formatter="formatter"
                label="企业名称"
                prop="OrgName"
                show-overflow-tooltip
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.OrgName || '--' }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="所属部门"
                width="150"
                prop="filed5"
                show-overflow-tooltip
                header-align="center"
                align="center"
              ></el-table-column>-->
              <el-table-column
                label="职务"
                max-width="150"
                prop="Job"
                show-overflow-tooltip
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{
                    (scope.row.Job && ZWArray[0][scope.row.Job]) || '暂无'
                  }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="专业"
                max-width="150"
                prop="MajorType"
                show-overflow-tooltip
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.MajorType && ZYArray[0][scope.row.MajorType] || "暂无" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="职称"
                max-width="150"
                prop="MajorTypeLevel"
                show-overflow-tooltip
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.MajorTypeLevel && ZCArray[0][scope.row.MajorTypeLevel] || "暂无" }}</span>
                </template>
              </el-table-column> -->
            </el-table>
            <div
              class="footer"
              style="display: flex; flex-direction: row-reverse"
            >
              <div class="page">
                <ps-page :page="page" @getData="getData()"></ps-page>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SysConfigServiceSvr } from '@/service/SysConfigMge/SysConfigServiceSvr';
import { devEnvironment, proEnvironment } from '@/assets/js/division';
import { OpenControllerSvr } from '@/service/OpenControllerSvr/OpenControllerSvr.js';
import { CommonControllerSvr } from '@/service/CommonControllerSvr/CommonControllerSvr.js';
import { headerredraw } from '@/mixin/headerredraw';
import { mapState } from 'vuex';
import { Page } from '@/models/page';
export default {
  name: 'PropertyProjectInformationInquiryList',
  metaInfo: {
    title: '业主大会和业委会查询',
    meta: [
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
      },
      { name: 'SiteName', content: '深圳市住房和建设局网站' },
      { name: 'SiteDomain', content: 'zjj.sz.gov.cn' },
      { name: 'SiteIDCode', content: '4403000005' },
      { name: 'ColumnName', content: '物业管理政策专题' },
      {
        name: 'ColumnDescription',
        content: '该栏目公布物业管理政策专栏的信息。',
      },
      { name: 'ColumnKeywords', content: '物业管理政策专栏' },
      { name: 'ColumnType', content: '其他' },
    ],
  },
  components: {},
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      page: new Page(),
      dataFeed: [],
      keyWords: '',
      dialogVisible: false,
      name: '',
      orgNme: '',
      paraNameArray: ['职务配置', '专业分类配置', '专业分类等级配置'],
      AllTypeArray: [],
      ZWArray: [],
      ZYArray: [],
      ZCArray: [],
      open: '',
      loading: false,
    };
  },
  computed: { ...mapState(['token']) },
  created() {
    this.sysConfigServiceSvr = new SysConfigServiceSvr();
    this.OpenControllerSvr = new OpenControllerSvr();
    this.CommonControllerSvr = new CommonControllerSvr();
    this.getAllType(this.paraNameArray);
    this.getData();
    this.getopen();
  },
  mounted() {},
  methods: {
    //空数据处理
    formatter(row, column, cellValue, index) {
      return cellValue === null || cellValue === '' ? '--' : cellValue;
    },
    getopen() {
      this.sysConfigServiceSvr
        .getSystemConfig('isDownLoadLocall')
        .then((res) => {
          this.open = res.isDownLoadLocall;
        })
        .catch((err) => [
          this.$message({
            type: 'error',
            message: err.Msg,
          }),
        ]);
    },
    //获取所有值的类
    getAllType(paraNameArray) {
      let temporary;
      this.CommonControllerSvr.GetConfigValueList('职务配置').then((res) => {
        temporary = [...[]];
        temporary[0] = '暂无';
        for (let { Key: key, Value: value } of res) {
          temporary[value] = key;
        }
        this.ZWArray.push(temporary);
      });
      this.CommonControllerSvr.GetConfigValueList('专业分类配置').then(
        (res) => {
          temporary = [...[]];
          temporary[0] = '暂无';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.ZYArray.push(temporary);
        }
      );
      this.CommonControllerSvr.GetConfigValueList('专业分类等级配置').then(
        (res) => {
          temporary = [...[]];
          temporary[0] = '暂无';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.ZCArray.push(temporary);
        }
      );

      // paraNameArray.map((currentValue, inedx) => {
      //   this.CommonControllerSvr.GetConfigValueList(currentValue)
      //     .then(
      //       res => {
      //         temporary = [...[]];
      //         temporary[0] = "暂无";

      //         if ((currentValue = "职务配置")) {
      //           for (let { Key: key, Value: value } of res) {
      //             temporary[value] = key;
      //           }
      //           this.ZWArray.push(temporary);
      //         }

      //         if ((currentValue = "专业分类配置")) {
      //           for (let { Key: key, Value: value } of res) {
      //             temporary[value] = key;
      //           }
      //           this.ZYArray.push(temporary);
      //         }

      //         if ((currentValue = "专业分类等级配置")) {
      //           for (let { Key: key, Value: value } of res) {
      //             temporary[value] = key;
      //           }
      //           this.ZCArray.push(temporary);
      //         }
      //       },
      //       err => {
      //         this.$message({
      //           message: err,
      //           type: "error"
      //         });
      //       }
      //     )
      //     .catch(() => {});
      // });
    },
    getData(state) {
      this.loading = true;
      if (state == 'clear') {
        this.page.currentPage = 1;
      }
      this.OpenControllerSvr.getEmployeeList(
        '',
        '',
        this.name,
        this.orgNme,
        0,
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum
      )
        .then(
          (res) => {
            this.loading = false;
            let someArray = [];
            this.page.getCurrtNum = res.TotalCount;
            res._Items.forEach((element, index) => {
              element.Employee['OrgName'] = element.OrgName;
              someArray.push(element.Employee);
            });
            this.dataFeed = someArray;
          },
          (err) => {
            this.loading = false;
            this.$message({
              message: err,
              type: 'error',
            });
          }
        )
        .catch(() => {
          this.loading = false;
        });
    },

    handleDetail(OrgCode, EmployeeNumber, job) {
      /*  if (job === 11) { */
      this.$router.push({
        path: '/PropertyProjectManagerDetails',
        query: {
          orgCode: OrgCode,
          employeeNumber: EmployeeNumber,
          userType: job,
        },
      });
      /*  } else {
        this.$router.push({
          path: "/EmployeeDetailInformation",
          query: { orgCode: OrgCode, employeeNumber: EmployeeNumber }
        });
      } */
    },
    epoxrtExcel() {
      //导出EXCEL
      if (process.env.NODE_ENV === 'development') {
        this.baseURL = devEnvironment;
      } else if (process.env.NODE_ENV === 'production') {
        this.baseURL = 'szwyweb/';
      }
      // var url = this.baseURL + 'httpfile.svt/exportEmployeeExpendList'; // 请求的url + id
      var url = this.baseURL + 'httpfile.svt/exportEmployeeExpendList'; // 请求的url + id
      var formData = new FormData();
      formData.append('token', this.token);
      formData.append('open', this.open);
      // formData.append('endTime', this.endTime);
      // formData.append('realtyComName','');

      var xhr = new window.XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.send(formData);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (this.status === 200) {
          var name = xhr.getResponseHeader('Content-disposition');
          var filename = name.substring(20, name.length);
          filename = decodeURI(filename);
          // .substr(filename.indexOf('filename='))
          var blob = this.response;
          var fileName = filename;
          if (window.navigator.msSaveOrOpenBlob) {
            // IE浏览器下
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.PublicInformationView {
  height: 100%;
  width: 100%;

  .container-boot {
    height: 100%;
    width: 100%;

    .table-grid {
      height: 100%;

      .grid {
        height: calc(100% - 60px);
      }
    }
  }

  padding: 0 10px;

  .container-header {
    text-align: right;
    margin-top: 6px;
    margin-bottom: 6px;
  }

  .search {
    text-align: right;

    .search-panel {
      display: inline;

      .search-tips {
        height: 40px;
        line-height: 40px;
        font-weight: bold;
        text-align: left;
        padding-left: 20%;
      }

      .el-input {
        .el-input__inner {
          width: 80%;
        }
      }

      .el-select {
        width: 100%;
      }
    }

    .search-button {
      margin-top: 20px;
    }
  }

  .row {
    height: 100%;

    .default-col {
      .el-table {
        height: calc(100% - 60px) !important;
        overflow: auto;

        .row-name {
          &:hover {
            text-decoration: underline;
            cursor: pointer;
          }
        }

        .has-gutter {
          color: black;
        }
      }

      // .table-grid {
      //   height: inherit
      // }
    }
  }
}
</style>
<style lang="scss" scoped>
.PropertyProjectInformationInquiryList {
  .header-seacher {
    .header-firstLine {
      .datetime {
        width: 480px;
      }

      .searchButton {
        width: 240px;
      }
    }
  }

  .function {
    min-width: 400px;
  }

  .container-boot {
    .grid {
      height: 100%;
    }
  }

  .el-dialog {
    .el-dialog__header {
      .dialog-title {
        font-size: 18px;

        .DialogTitle {
          font-size: 18px;
          color: #409eff;
        }
      }
    }

    .el-dialog__body {
      height: 630px;
      overflow: auto;
      padding: 0 !important;
    }
  }
}
</style>
